<div class="card-header pb-0">
  <div class="media-space-between">
    <h4>{{ "dashboard.franchise.topFranchised.title" | translate }}</h4>
    <div class="d-flex align-items-end" style="gap: 10px">
      <app-date-range-picker
        [form]="formFilter"
        inputFormControlName="date"
        [max]="today"
      ></app-date-range-picker>
      <app-refresh-button
        [state]="fetchingLocationPartnerPreviewState"
        [date]="cachedAt"
        (buttonClick)="onClickRefreshCache()"
      ></app-refresh-button>
    </div>
  </div>
</div>
<div class="card-body" id="dashboard.admin.lpReview.title">
  <div class="table-responsive data-table">
    <form id="dashboard.admin.lpReview.title">
      <table class="table table-striped table-border-vertical">
        <tbody *ngIf="!loading">
          <tr *ngFor="let franchised of topFranchised; let i = index">
            <td class="d-flex">
              <div class="dark-ball">{{ i + 1 }}</div>
              <a
                type="button"
                [routerLink]="[
                  '/',
                  'dashboard',
                  'franchise',
                  'locations',
                  'repository',
                  'statistics'
                ]"
                style="color: black"
                [queryParams]="{
                  companyName: franchised.companyName
                }"
              >
                {{ franchised.companyName }}
              </a>
            </td>
            <td class="text-primary">
              {{ franchised.impressions | toKValue }}
              {{
                "dashboard.franchise.topFranchised.indicator.impressions"
                  | translate
              }}
            </td>
            <td class="text-primary">
              {{ franchised.uniqueUsers | toKValue }}
              {{
                "dashboard.franchise.topFranchised.indicator.uniqueUsers"
                  | translate
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="loading && !forbidden">
        <ng-container style="float: right" class="flex">
          <div class="loader-box">
            <div class="loader-34"></div>
          </div>
          <h6 class="col align-self-center f-w-600" style="text-align: center">
            {{ "fetching" | translate }}
          </h6>
        </ng-container>
      </div>
      <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
        {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
      </div>
      <div
        *ngIf="topFranchised.length == 0 && !loading && !forbidden"
        class="d-flex justify-content-center m-t-20"
      >
        {{ "noData" | translate }}
      </div>
    </form>
  </div>
  <div class="m-t-10 d-flex justify-content-end">
    <span
      class="d-flex align-items-baseline cursor-pointer"
      [routerLink]="['/', 'dashboard', 'franchise', 'locations', 'repository']"
      ><p class="text-decoration-underline mb-0">
        {{ "dashboard.franchise.topFranchised.allFranchised" | translate }}
      </p>
      <i class="icofont icofont-simple-right"></i
    ></span>
  </div>
</div>
